import { render, staticRenderFns } from "./SignalEventDetail.vue?vue&type=template&id=32eeb7f3&"
import script from "./SignalEventDetail.vue?vue&type=script&lang=js&"
export * from "./SignalEventDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32eeb7f3')) {
      api.createRecord('32eeb7f3', component.options)
    } else {
      api.reload('32eeb7f3', component.options)
    }
    module.hot.accept("./SignalEventDetail.vue?vue&type=template&id=32eeb7f3&", function () {
      api.rerender('32eeb7f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/gva-wfd/components/DetailPanel/SignalEventDetail.vue"
export default component.exports